import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReviewStudentOfConcernInterviewComponent } from "../../../../components/review-content/review-student-of-concern-interview/review-student-of-concern-interview.component";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'student-interview-submission',
  standalone: true,
  imports: [
    CommonModule,
    ReviewStudentOfConcernInterviewComponent
  ],
  templateUrl: './student-interview-submission.component.html',
  styleUrl: './student-interview-submission.component.css'
})
export class StudentInterviewSubmissionComponent {

  @Input() studentInterviewData: any = {};
  @Output() onSaveSection8 = new EventEmitter<any>();

  currentCaseId: string | null = null;

  ngOnInit(): void {
    if (this.studentInterviewData) {
      this.currentCaseId = this.studentInterviewData.case_id;
    }
  }

  submitWitnessInterview(): void {
    this.onSaveSection8.emit({});
  }

}
